var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoution = function SvgCoution(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67984 8.0033H5.56555",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3365 8.0033H24.4845L21.9215 17.5134H8.26343",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 19.8403H10.4555C9.54498 19.8403 8.76934 19.2333 8.49955 18.3565L8.26348 17.5134L5.56559 8.03704L4.99229 6.04735C4.7225 5.13681 3.91313 4.52979 3.00259 4.52979H0.675659",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.265 25.0001C12.2148 25.0001 12.9849 24.23 12.9849 23.2801C12.9849 22.3303 12.2148 21.5602 11.265 21.5602C10.3151 21.5602 9.54504 22.3303 9.54504 23.2801C9.54504 24.23 10.3151 25.0001 11.265 25.0001Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9539 25.0001C19.9038 25.0001 20.6738 24.23 20.6738 23.2801C20.6738 22.3303 19.9038 21.5602 18.9539 21.5602C18.004 21.5602 17.234 22.3303 17.234 23.2801C17.234 24.23 18.004 25.0001 18.9539 25.0001Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6284 13.8036H10.4219C10.0172 13.8036 9.67993 13.4664 9.67993 13.0617V6.85657H20.3366V13.0954C20.3366 13.4664 20.0331 13.8036 19.6284 13.8036Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8424 6.85665H9.20772C8.73558 6.85665 8.36462 6.48569 8.36462 6.01356V4.9344C8.36462 4.46227 8.73558 4.09131 9.20772 4.09131H20.8087C21.2808 4.09131 21.6517 4.46227 21.6517 4.9344V6.01356C21.6855 6.45196 21.3145 6.85665 20.8424 6.85665Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0846 4.05761C10.0846 4.05761 8.90422 -2.82201 14.3 4.05761V6.85667",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9319 4.05761C19.9319 4.05761 21.1122 -2.82201 15.7164 4.05761V6.85667",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coution.94d5777f.svg";
export { ForwardRef as ReactComponent };